<template>
  <div v-loading="loading">
    <!-- <flow-cate :curIndex="curIndex" :all="false" :flowCates="cates" @watchWinSizeChange="pageResize" @selectCate="selectCate"></flow-cate> -->
    <div class="ovf-hd">
<!--       <div class="ovf-hd">
        <slot name="myFlow"></slot>
        <div class="fl w-300" @keyup.enter="search()">
          <el-input v-model="keywords" placeholder="输入流程名称搜索"></el-input>
        </div>
        <div class="fl m-l-20">
          <el-button type="primary" @click="search">搜索</el-button>
        </div>
        <div class="fr" v-if="caseId == 3">
          <el-button type="success" @click="">导出</el-button>
        </div>
      </div> -->
      <div v-if="flowsShow.length > 0">
        <div class='ovf-hd p-b-10 tabTitle' :class="{ 'm-t-20': index != 0, 'm-t-30': index == 0 }" v-for="(fitem, index) in flowsShow">
          <div class='fw-b'><span class='line'></span>{{fitem.name}}</div>
          <div 
          v-for="(item, findex) in fitem.list" 
          class="fl m-t-10 bg-wh w-190 h-190 tx-c pointer addFlow-cate" 
          :class="{'m-r-10': (1 + findex) % 6 != 0}" 
          @click="creatFlow(item.id)">
            <div class="w-60 flow-icon" style="height: 60px;" :class="item.icon"></div>
            <div class="flow-name fz-18 h-25 text-overflow" :title="item.name">{{item.name}}</div>
            <div class="flow-desc m-t-12 c-gra text-overflow fz-14" style="height: 50px;" :title="item.description">{{item.description}}</div>
            <el-button type="primary" class="flow-btn w-110 m-t-20 fz-14">
              <i class="fa fa-plus-circle c-wh"></i>
              &nbsp;发起流程
            </el-button>
          </div>
        </div>
      </div>
      <div class="fl m-t-20 noData tx-c p-t-50 p-b-80" v-else>
        <span class='null'>无相关数据</span>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .null {
    color: #5e7382;
    font-size: 14px;

  }
  .line{
    position: absolute;
    top: 4px;
    left: 0px;
    width: 3px;
    height: 18px;
    display: inline-block;
    background: #20a0ff;
  }
  .tabTitle{
    position: relative;
    font-size: 18px;
    text-indent: 8px;
    line-height: 25px;
    /*padding-top: 20px;*/
  }
  .panel-c-c {
    padding: 0 !important;
  }
  .addFlow-cate {
    transition: all .5s;
  }
  .addFlow-cate:hover {
    box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.1);
    -o-box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.1);
    -ms-box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.1);
    transition: all .5s;
  }
  .addFlow-cate .flow-icon {
    opacity: 1;
    transition: all .3s;
		margin: 50px auto 0 auto;
  }
  .addFlow-cate:hover .flow-icon {
    opacity: 0;
    transition: all .3s
  }
  .addFlow-cate .flow-name {
    color: #333333;
    margin-top: 20px;
    padding: 0 10px;
    transition: all .3s
  }
  .addFlow-cate:hover .flow-name {
    margin-top: -86px;
    transition: all .3s
  }
  .addFlow-cate .flow-desc {
    color: #666666 !important;
    padding: 0 10px;
    opacity: 0;
    transition: all .3s
  }
  .addFlow-cate:hover .flow-desc {
    opacity: 1;
    transition: all .3s
  }
  .addFlow-cate .flow-btn {
    height: 37px;
    opacity: 0;
    transition: all .3s
  }

  .addFlow-cate:hover .flow-btn {
    opacity: 1;
    transition: all .3s
  }
  .noData {
    width:100%;
    padding:10px;
    background-color:#fff;
  }
</style>

<script>
  import flowCate from '../common/flowCate.vue'
  import http from '../../../assets/js/http'

  export default {
    name: 'addFlow',
    props: {
      name: {
        type: String,
        default() {
          return ''
        }
      },
      cateId: {
        type: Number,
        default() {
          return 0
        }
      }
    },
    data() {
      return {
        loading: false,
        cates: [],
        flowsShow: [],
        flows: [],
        keywords: '',
        path: '',
        curIndex: 0,
        curScrollTop: 0, // 记录当前的curScrollTop值
        top: [] // 记录每个tab标题离内容区域的顶部距离
      }
    },
    methods: {
      async getFlowCates() {
        let arr = []
        let res = await this.apiGet('bpm/types/side')
        return this.promiseHandler(arr, res)

        // this.apiGet('bpm/types/side').then((res) => {
        //   if (res.code == 200) {
        //     _(res.data).forEach((res) => {
        //       res.selected = false
        //     })
        //     this.cates = res.data
        //   } else {
        //     _g.dealError(this, res)
        //   }
        // })
      },
      sortFlowShow() {
        let flowShow = []
        if (this.flows.length == 0) {
          this.flowsShow = flowShow
          return
        }
        // 常用流程
        let list = []
        _(this.flows).forEach((fres) => {
          if (fres.is_used == 1) {
            list.push(fres)
          }
        })
        flowShow.push({ name: '常用流程', list: list })
        // 分类
        _(this.cates).forEach((cres) => {
          let flow = { name: '', list: [] }
          flow.name = cres.name
          _(this.flows).forEach((fres) => {
            if (cres.id == fres.type_id) {
              flow.list.push(fres)
            }
          })
          flowShow.push(flow)
        })
        this.flowsShow = flowShow
      },
      getFlows() {
        this.loading = !this.loading
        let query = {
          params: {
            status: 1,
            isFilter: 1,
            limit: this.limit,
            keywords: this.keywords
          }
        }
        this.apiGet('bpm/flows', query).then((res) => {
          this.loading = !this.loading
          if (res.code == 200) {
            this.flows = res.data.list
            // this.flowsShow = _.cloneDeep(this.flows)
            this.sortFlowShow()
          } else {
            _g.dealError(this, res)
          }
        })
      },
      selectCate(val) { // 点击左边分组名，切换内容
        let tabTitle = document.getElementsByClassName('tabTitle')
        let index = 0
        if (val != 0) {
          _(this.cates).forEach((res, key) => {
            if (res.id == val) {
              index = key + 1
              return
            }
          })
        }
        console.log('index', index)
        tabTitle[index].scrollIntoView()
        setTimeout(() => {
          if (val != 0) {
            this.clearSelectedItem()
            this.curIndex = index
            this.cates[index - 1]['selected'] = true
          }
        }, 100)
      },
      getFlowsByCate(cid) {
        let arr = []
        _(this.flows).forEach((res) => {
          if (res.type_id == cid) {
            arr.push(res)
          }
        })
        return arr
      },
      creatFlow(id) {
        router.push({ name: 'flowForm', params: { id: id }})
      },
      search() {
        router.push({ path: this.path, query: { keywords: this.keywords, limit: this.limit }})
      },
      resetFilter(route) {
        this.keywords = route.query.keywords
        // this.$emit('setKeywords', route.query.keywords)
        // this.limit = parseInt(route.query.limit) ? parseInt(route.query.limit) : 10
      },
      getTops() {
        this.top = []
        let tabTitle = document.getElementsByClassName('tabTitle')
        for (let i = 0; i < tabTitle.length; i++) {
          this.top.push(tabTitle[i].offsetTop - tabTitle[0].offsetTop)
        }
      },
      clearSelectedItem() {
        _(this.cates).forEach((res) => {
          res.selected = false
        })
      },
      getCurTab(scrollTop) { // 确定当前选中的tab
        // 让顶部的菜单栏变为固定定位
        let fixedMenu = document.getElementsByClassName('fixedMenu')[0]
        let topMenu = document.getElementsByClassName('topMenu')[0]
        if (this.curScrollTop - scrollTop > 0) {
          // 往上滚动
          fixedMenu.style.opacity = 1
        } else {
          // 往下滚动
          fixedMenu.style.opacity = 0
        }
        if (scrollTop - topMenu.offsetHeight < 0) {
          fixedMenu.style.height = '0px'
        }
        this.curScrollTop = scrollTop
        // console.log(scrollTop)
        let curTabIndex = 0
        // this.clearSelectedItem()
        _(this.top).forEach((res, key) => {
          if ((this.top[key] - 100) < scrollTop) {
            curTabIndex = key
            return false
          }
        })
        // console.log(curTabIndex)
        this.$emit('setCurCate', curTabIndex)
      },
      pageResize() {
        let panelContent = document.getElementById('panelContent')
        let scrollTop = panelContent.scrollTop || panelContent.pageYOffset
        this.getTops()
        // this.getCurTab(scrollTop)
      }
    },
    async created() {
      this.path = this.$route.path
      let cates = await this.getFlowCates()
      _(cates).forEach((res) => {
        res.selected = false
      })
      this.cates = cates
      this.getFlows()
    },
    mounted() {
      // let panelContent = document.getElementById('panelContent')
      // panelContent.onscroll = () => {
      //   this.pageResize()
      // }
    },
    beforeDestroy() {
      let that = this
      let panelContent = document.getElementById('panelContent')
      panelContent.onscroll = null
    },
    watch: {
      '$route' (to, from) {
        this.resetFilter(to)
        this.getFlows()
      }
    },
    computed: {
    },
    components: {
      flowCate
    },
    mixins: [http]
  }

</script>


// WEBPACK FOOTER //
// addFlow.vue?59331474